





import { Component, Watch, Vue, Prop } from "vue-property-decorator";
import api from "../../api/index";
import mapboxgl from "mapbox-gl";

@Component({
	components: {},
})
export default class CondominiumListMap extends Vue {
	condominiumPosition: any = [];
	condominiumsPositions: any = [];
	condominiumsPositionsFeatures: any = [];

	@Prop({ default: null })
	selectedCondominium: any;

	@Prop({ default: null })
	condominiums: any;

	@Prop({ default: null })
	pageClass: any;

	async mounted() {
		await this.getAllCondominiumsPositions(this.condominiums);
		if (this.condominiums)
			await this.getSelectedCondominiumPosition(this.condominiums[0]);
	}

	@Watch("selectedCondominium")
	updateMap() {
		this.getSelectedCondominiumPosition(this.selectedCondominium);
	}

	async getSelectedCondominiumPosition(condominium: any) {
		this.$geocoder.setDefaultMode("address"); // this is default
		var addressObj = {
			address_line_1: condominium.address,
			city: condominium.city,
			zip_code: condominium.zip_code, // postal_code also valid
			country: condominium.country,
		};
		await this.$geocoder.send(addressObj, async (response: any) => {
			this.condominiumPosition = [
				response.results[0].geometry.location.lng,
				response.results[0].geometry.location.lat,
			];
			await this.drawMap();
		});
	}

	async getAllCondominiumsPositions(condominiums: any) {
		this.$geocoder.setDefaultMode("address");
		for (var i = 0; i < condominiums.length; i++) {
			var addressObj = {
				address_line_1: condominiums[i].address,
				city: condominiums[i].city,
				zip_code: condominiums[i].zip_code,
				country: condominiums[i].country,
			};
			await this.$geocoder.send(addressObj, async (response: any) => {
				this.condominiumsPositions.push([
					response.results[0].geometry.location.lng,
					response.results[0].geometry.location.lat,
				]);
			});
		}
	}

	async drawMap() {
		const this2 = this;
		mapboxgl.accessToken = process.env.VUE_APP_MAPBOX_ACCESS_TOKEN;
		var lng = this.condominiumPosition[0];
		var lat = this.condominiumPosition[1];

		var map: any = new mapboxgl.Map({
			container: "map",
			style: process.env.VUE_APP_MAPBOX_STYLE,
			center: [lng, lat], // starting position [lng, lat]
			zoom: 13, // starting zoom
		});

		for (var i = 0; i < this.condominiums.length; i++) {
			this.condominiumsPositionsFeatures.push({
				type: "Feature",
				geometry: {
					type: "Point",
					coordinates: [
						this.condominiumsPositions[i][0],
						this.condominiumsPositions[i][1],
					],
				},
				properties: this.condominiums[i],
			});
		}
		var features = this.condominiumsPositionsFeatures;

		map.on("load", function () {
			map.loadImage("/geo-pin.png", function (error: any, image: any) {
				if (error) throw error;
				map.addImage("test", image);

				map.addLayer({
					id: "test",
					type: "symbol",
					source: {
						type: "geojson",
						data: {
							type: "FeatureCollection",
							features: features,
						},
					},
					layout: {
						"icon-image": "test",
						"icon-size": 0.25,
					},
				});
			});
		});

		map.on("load", function () {
			map.loadImage("/main-geo-pin.png", function (error: any, image: any) {
				if (error) throw error;
				map.addImage("cat", image);

				map.addLayer({
					id: "points",
					type: "symbol",
					source: {
						type: "geojson",
						data: {
							type: "FeatureCollection",
							features: [
								{
									properties: this2.selectedCondominium,
									type: "Feature",
									geometry: {
										type: "Point",
										coordinates: [lng, lat],
									},
								},
							],
						},
					},
					layout: {
						"icon-image": "cat",
						"icon-size": 0.25,
					},
				});
			});
		});

		map.on("click", "test", function (e: any) {
			this2.$router.push({
				name: "condominiumProfile",
				params: { condominiumId: e.features[0].properties.id },
			});
		});

		map.on("click", "points", function (e: any) {
			this2.$router.push({
				name: "condominiumProfile",
				params: { condominiumId: e.features[0].properties.id },
			});
		});
	}
}
